import { AppDispatch, RootState } from '@/store/index';
import { HomeSlice } from '@/store/Reducers/homeReducer';
import { addToast } from '@heroui/react';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';

type Props = {
  children: JSX.Element;
};

const ToastLayout = ({ children }: Props) => {
  const dispatch = useDispatch<AppDispatch>();
  const loading = useSelector((state: RootState) => state.homeReducer.loading);
  const toastQueue = useSelector(
    (state: RootState) => state.homeReducer.toastQueue,
  );

  useEffect(() => {
    if (!loading && !!toastQueue?.length) {
      toastQueue.forEach((t) =>
        addToast({
          title: t.message,
          color: t.level === 'success' ? 'success' : 'danger',
        }),
      );
      dispatch(HomeSlice.actions.emptyToastQueue());
    }
  }, [toastQueue, loading]);

  return <>{children}</>;
};

export default ToastLayout;
